import React, { Component } from 'react';
import './style.css';
import T from 'i18n-react';
import SkipAuthIcon from '../../images/UnableToAuthorizeIcon.svg'
import MyCRAIcon from '../../images/MyCRAIcon.svg';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent'
import { Fragment } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux'
class AuthorizeSelectCtrl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lang: this.props.lang,
            prepareForSpouse: this.props.prepareForSpouse,
            firstName: this.props.firstName,
            spouseFirstName: this.props.spouseFirstName,
            selectOption: this.props.selectOption,
            authChoiceSpouse: this.props.authChoiceSpouse,
            authChoiceSelf: this.props.authChoiceSelf,
            isPrimaryCRAAuthComplete: this.props.isPrimaryCRAAuthComplete,
            isSpouseCRAAuthComplete: this.props.isSpouseCRAAuthComplete
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.lang !== newProps.lang) {
            this.setState({ lang: newProps.lang })
        }
        if (this.state.spouseFirstName !== newProps.spouseFirstName) {
            this.setState({ spouseFirstName: newProps.spouseFirstName })
        }
        if (this.state.firstName !== newProps.firstName) {
            this.setState({ firstName: newProps.firstName })
        }
        if (this.state.prepareForSpouse !== newProps.prepareForSpouse) {
            this.setState({ prepareForSpouse: newProps.prepareForSpouse })
        }
        if (this.state.selectOption !== newProps.selectOption) {
            this.setState({ selectOption: newProps.selectOption })
        }
        if (this.state.authChoiceSpouse !== newProps.authChoiceSpouse) {
            this.setState({ authChoiceSpouse: newProps.authChoiceSpouse })
        }
        if (this.state.authChoiceSelf !== newProps.authChoiceSelf) {
            this.setState({ authChoiceSelf: newProps.authChoiceSelf })
        }
    }

    selectOption(target, option) {
        if (this.state.selectOption) {
            this.state.selectOption(target, option)
        }
    }

    render() {
        return (
            <Fragment>
                <div className='auth-selection-card-wrapper'>
                    <Card elevation={1} className='auth-card'>
                        <CardContent className={classnames('auth-card-content', this.state.lang === 'fr' ? this.state.prepareForSpouse ? 'auth-card-content-fr-s' : 'auth-card-content-fr' : this.state.prepareForSpouse ? 'auth-card-content-s' : '')}>
                            <div className={classnames('authorizeSelectCtrlOptionContentHeader', this.state.lang === 'fr' ? 'authorizeSelectCtrlOptionContentHeader-fr' : '')}>
                                <img src={MyCRAIcon} width={45} height={45} />
                                <div className='auth-type-header-wrapper'>
                                    <div className='auth-type-header'>
                                        {T.translate('Authorize.CRATitle')}
                                    </div>
                                    <div className='auth-type-recommended'>
                                        {T.translate('Authorize.Recommended')}
                                    </div>
                                </div>
                            </div>
                            <div className='auth-selection-content-wrapper'>
                                <div className={classnames('auth-selection-subtext', this.state.lang === 'fr' ? 'auth-selection-subtext-fr' : '')}>
                                    {T.translate('Authorize.OptionCRASubtext')}
                                </div>
                                <div>
                                    <div className='auth-selection-component-wrapper'>
                                        <input type='radio' id='MyCRASelectionPrimaryRadio' checked={this.state.authChoiceSelf === 'MyCRA'} className='auth-select-radio' onChange={() => this.selectOption('self', 'MyCRA')} disabled={this.state.isPrimaryCRAAuthComplete} />
                                        <label htmlFor='MyCRASelectionPrimaryRadio' className={classnames('auth-selection-label', { 'auth-selection-label-disabled': this.state.isPrimaryCRAAuthComplete })}>{this.state.firstName}</label>
                                    </div>
                                    {this.state.prepareForSpouse &&
                                        <div className='auth-selection-component-wrapper'>
                                            <input type='radio' id='MyCRASelectionSpouseRadio' checked={this.state.authChoiceSpouse === 'MyCRA'} className='auth-select-radio' onChange={() => this.selectOption('spouse', 'MyCRA')} disabled={this.state.isSpouseCRAAuthComplete} />
                                            <label htmlFor='MyCRASelectionSpouseRadio' className={classnames('auth-selection-label', { 'auth-selection-label-disabled': this.state.isSpouseCRAAuthComplete })}>{this.state.spouseFirstName}</label>
                                        </div>}
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                    <div className='auth-card-or'>
                        {T.translate('Authorize.OptionsOr')}
                    </div>
                    <Card elevation={1} className='auth-card'>
                            <CardContent className={classnames('auth-card-content', this.state.lang === 'fr' ? this.state.prepareForSpouse ? 'auth-card-content-fr-s' : 'auth-card-content-fr' : this.state.prepareForSpouse ? 'auth-card-content-s' : '')}>
                                <div className={classnames('authorizeSelectCtrlOptionContentHeader', this.state.lang === 'fr' ? 'authorizeSelectCtrlOptionContentHeader-fr' : '')}>
                                    <img src={SkipAuthIcon} width={45} height={45} />
                                    <div className='auth-type-header-wrapper'>
                                        <div className='auth-type-header'>
                                            {T.translate('Authorize.SkipAuthorization')}
                                        </div>
                                    </div>
                                </div>
                                <div className='auth-selection-content-wrapper'>
                                    <div className={classnames('auth-selection-subtext', this.state.lang === 'fr' ? 'auth-selection-subtext-fr' : '')}>
                                        {T.translate('Authorize.OptionSkipSubtext')}
                                    </div>
                                    <div>
                                        <div className='auth-selection-component-wrapper'>
                                            <input type='radio' id='SkipAuthPrimaryRadio' checked={this.state.authChoiceSelf === 'SkipAuth'} className='auth-select-radio' onChange={() => this.selectOption('self', 'SkipAuth')} disabled={this.state.isPrimaryCRAAuthComplete} />
                                            <label htmlFor='SkipAuthPrimaryRadio' className={classnames('auth-selection-label', { 'auth-selection-label-disabled': this.state.isPrimaryCRAAuthComplete })}>{this.state.firstName}</label>
                                        </div>
                                        {this.state.prepareForSpouse &&
                                            <div className='auth-selection-component-wrapper'>
                                                <input type='radio' id='SkipAuthSpouseRadio' checked={this.state.authChoiceSpouse === 'SkipAuth'} className='auth-select-radio' onChange={() => this.selectOption('spouse', 'SkipAuth')} disabled={this.state.isSpouseCRAAuthComplete} />
                                                <label htmlFor='SkipAuthSpouseRadio' className={classnames('auth-selection-label', { 'auth-selection-label-disabled': this.state.isSpouseCRAAuthComplete })}>{this.state.spouseFirstName}</label>
                                            </div>}
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {        
        isPrimaryCRAAuthComplete: state.authorizeCRA?.authorizeStateSelf?.cra_status,
        isSpouseCRAAuthComplete: state.authorizeCRA?.authorizeStateSpouse?.cra_status
    }
}
export default connect(mapStateToProps)(AuthorizeSelectCtrl)